import type {
  MediatorTransitionResult,
  TypedEvent,
} from "@/shared/lib/componentHierarchy";

export interface AnnouncementRequest {
  announcementId?: number;
}

export type DesktopLayoutEvent =
  | { type: "desktop-layout.announcement.open"; announcementId?: number }
  | { type: "desktop-layout.announcement.close" };

export function transitionDesktopLayout(
  _state: AnnouncementRequest | null,
  event: TypedEvent,
): MediatorTransitionResult<AnnouncementRequest | null, never> {
  if (event.type === "desktop-layout.announcement.close") {
    return { status: "handled", state: null };
  }
  if (event.type === "desktop-layout.announcement.open") {
    const request = event as Extract<
      DesktopLayoutEvent,
      { type: "desktop-layout.announcement.open" }
    >;
    return {
      status: "handled",
      state: { announcementId: request.announcementId },
    };
  }
  return { status: "unhandled" };
}
